import React from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-js';
import { Box } from '@material-ui/core';
import useStyles from './ItemList.styled';
import { ItemDetails } from 'components/UI';
import Paginator from 'components/Paginator';

const ItemsList = ({
  list,
  params,
  idLabel,
  userLabel,
  dateLabel,
  dateField,
  pagination,
  scrollable,
  placeholder,
  handleItemClick,
  onPageChange,
  footerDirection,
  rowsPerPageOptions,
  handleChangeRowsPerPage,
}) => {
  const classes = useStyles();

  return (
    <Box>
      {list?.length > 0 ? (
        <>
          <Box className={scrollable ? classes.boxContainerScrollable : classes.boxContainer}>
            {list.map((item, index) => (
              <ItemDetails
                key={index}
                id={item?.id}
                instance={
                  item?.primary_object_type
                    ? {
                        type: item.primary_object_type,
                        id: item.primary_object_id,
                      }
                    : null
                }
                user={item?.owner_user}
                date={item?.[dateField]}
                type={item?.type}
                collapsible={item?.collapsible}
                collapsibleContent={item?.collapsible && item?.collapsibleContent}
                idLabel={idLabel && `${idLabel}${item?.id}`}
                priority={item?.priority || item?.current_priority}
                title={item?.display_name}
                description={item?.description}
                handleItemClick={handleItemClick}
                userLabel={userLabel || i18n.t('tasks.assigned_to')}
                dateLabel={dateLabel || i18n.t('tasks.opened_since')}
                footerDirection={footerDirection}
              />
            ))}
          </Box>
          <Paginator
            component="div"
            limit={params.limit}
            pagination={pagination}
            onPageChange={onPageChange}
            rowsPerPageOptions={rowsPerPageOptions}
            labelRowsPerPage={i18n.t('common.page_size')}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </>
      ) : (
        <Box>{placeholder}</Box>
      )}
    </Box>
  );
};

ItemsList.propTypes = {
  scrollable: PropTypes.bool,
  dateField: PropTypes.string,
  placeholder: PropTypes.string,
  list: PropTypes.array.isRequired,
  rowsPerPageOptions: PropTypes.array,
  pagination: PropTypes.object.isRequired,
  params: PropTypes.object,
  handleItemClick: PropTypes.func.isRequired,
  onPageChange: PropTypes.func.isRequired,
  handleChangeRowsPerPage: PropTypes.func.isRequired,
  idLabel: PropTypes.string,
  userLabel: PropTypes.string,
  dateLabel: PropTypes.string,
  footerDirection: PropTypes.string,
};
ItemsList.defaultProps = {
  scrollable: true,
  dateField: 'opened_time',
  handleItemClick: () => {},
  onPageChange: () => {},
  handleChangeRowsPerPage: () => {},
  rowsPerPageOptions: [10, 25, 50, 100],
  placeholder: i18n.t('common.empty_list'),
};

export default ItemsList;
